import React, { Fragment } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import Section from '../common/Section';
import SectionHeader from '../common/SectionHeader';
import DecipherIcon from '../../assets/images/decipher.png';
import IntervuIcon from '../../assets/images/intervu.png';
import RevelationIcon from '../../assets/images/revelation.png';
import LiveVideoIcon from '../../assets/images/livevideo.png';
import ProjectForm from './ProjectForm';
import { DEFAULT_ERROR_STATUS, DEFAULT_PROJECT_STATUS } from '../../config/projectSettings';
import { ProjectContext } from './ProjectContext';

const ProjectTypeOption = ({ icon, name, value, checked, onChange }) => (
  <figure>
    <label>
      <img src={icon} width="118" height="118" alt={name} />
      <figcaption>
        <input type="radio" name="project" value={value} onChange={onChange} checked={checked} />
        <span>{name}</span>
      </figcaption>
    </label>
  </figure>
);

class CreateProject extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.renderProjectForm = this.renderProjectForm.bind(this);

    this.state = {
      selected: 0
    }
  }

  onChange(event) {
    this.setState({ selected: event.target.value });
  }

  renderCreate() {
    return (
      <React.Fragment>
        <SectionHeader title="Add a Project" />
        <Section className="add-project">
          <h2>Select a Product to Create a project</h2>
          <form>
            <fieldset>
              <ProjectTypeOption
                name="IntreVu"
                icon={IntervuIcon}
                onChange={this.onChange}
                value={0}
                checked={this.state.selected == 0} />
              <ProjectTypeOption
                name="Decipher TES"
                icon={DecipherIcon}
                onChange={this.onChange}
                value={1}
                checked={this.state.selected == 1} />
              <ProjectTypeOption
                name="Revelation"
                icon={RevelationIcon}
                onChange={this.onChange}
                value={2}
                checked={this.state.selected == 2} />
              <ProjectTypeOption
                name="LiveVideo"
                icon={LiveVideoIcon}
                onChange={this.onChange}
                value={3}
                checked={this.state.selected == 3} />
            </fieldset>
            <fieldset>
              <Link to={`/projects/create/${this.state.selected}`} className="blue-btn">Next</Link>
            </fieldset>
          </form>
        </Section>
      </React.Fragment>
    );
  }

  renderProjectForm(routeProps) {

    const { match: { params } } = routeProps;

    const project = {
      attributes: {
        projectType: Number(params.projectType),
        status: DEFAULT_PROJECT_STATUS,
        completionStatus: DEFAULT_ERROR_STATUS
      }
    };

    return (
      <ProjectForm
        project={project}
        title="Create project"
        {...routeProps} />
    );
  }

  render() {

    return (
      <Fragment>
        <Switch>
          <ProjectContext.Provider value={{ returnPath: "/projects/create" }}>
            <Route path="/projects/create" exact render={this.renderCreate} />
            <Route path="/projects/create/:projectType" render={this.renderProjectForm} />
          </ProjectContext.Provider>
        </Switch>
      </Fragment>
    );
  }
}

export default CreateProject;



// WEBPACK FOOTER //
// ./src/components/projects/CreateProject.js